import React from 'react';
import { Link } from 'react-router-dom';
import { Stethoscope, Hand, PackageCheck, ParkingCircle, Store, ArrowRight } from 'lucide-react';

const REASONS = [
  {
    icon: Stethoscope,
    title: 'Aconselhamento técnico por especialistas',
    desc: 'Atendimento personalizado por técnicos ortopédicos com mais de 15 anos de experiência. Avaliamos as suas necessidades e recomendamos o equipamento ideal.',
  },
  {
    icon: Hand,
    title: 'Experimente antes de comprar',
    desc: 'Teste poltronas, cadeiras de rodas, andarilhos e calçado ortopédico antes de decidir. Garantimos que o equipamento se adapta a si.',
  },
  {
    icon: PackageCheck,
    title: 'Levantamento imediato sem custos de envio',
    desc: 'Compre e leve na hora. Sem espera por entregas, sem custos de transporte. Stock disponível para levantamento no próprio dia.',
  },
  {
    icon: ParkingCircle,
    title: 'Estacionamento e fácil acesso',
    desc: 'Ambas as lojas têm estacionamento fácil nas imediações e acesso sem barreiras — ideal para utilizadores de cadeiras de rodas e mobilidade reduzida.',
  },
];

export default function WhyBuyInStore({ compact = false, accentColor = '#0e6b4f' }) {
  return (
    <section className={`py-10 px-4 ${compact ? '' : 'bg-slate-50'}`}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-3" style={{ background: `${accentColor}15`, color: accentColor }}>
            <Store className="w-4 h-4" />
            <span className="text-xs font-bold uppercase tracking-wider">Vendas Presenciais</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-2">
            Porquê comprar na nossa loja física?
          </h2>
          <p className="text-slate-600 text-sm sm:text-base max-w-2xl mx-auto">
            Visite as nossas lojas em <strong>Benfica</strong> e <strong>Junqueira</strong> em Lisboa e receba atendimento personalizado de especialistas ortopédicos.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div key={i} className="bg-white rounded-xl border border-slate-200 p-5 flex gap-4 hover:shadow-md transition-shadow">
                <div className="shrink-0 w-11 h-11 rounded-xl flex items-center justify-center" style={{ background: `${accentColor}12` }}>
                  <Icon className="w-5 h-5" style={{ color: accentColor }} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-sm mb-1">{r.title}</h3>
                  <p className="text-xs text-slate-600 leading-relaxed">{r.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/loja-ortopedia-benfica" className="inline-flex items-center justify-center gap-2 text-white font-bold px-6 py-3 rounded-xl text-sm transition" style={{ background: accentColor }}>
            Ver Loja de Benfica <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/loja-ortopedia-junqueira" className="inline-flex items-center justify-center gap-2 text-white font-bold px-6 py-3 rounded-xl text-sm transition" style={{ background: accentColor }}>
            Ver Loja da Junqueira <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}